/**
 * Format a date string to YYYY-MM-DD
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toISOString().split('T')[0];
  } catch {
    return dateStr;
  }
};

/**
 * Format a datetime string to YYYY-MM-DD HH:mm
 */
export const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return `${date.toISOString().split('T')[0]} ${date.toTimeString().slice(0, 5)}`;
  } catch {
    return dateStr;
  }
};
